import { css } from '@emotion/react';
import styled from '@emotion/styled';
import ClueNoteIcon from '~/assets/img/icons/clue_note_icon.png';
import { useMysteryChatStore } from '~/store';

export default function ClueNote() {
  const setShowCaseNotes = useMysteryChatStore(
    (state) => state.setShowCaseNotes,
  );

  return (
    <Container>
      <Button onClick={() => setShowCaseNotes(true)}>
        <img src={ClueNoteIcon} alt='clue_note_icon' />
      </Button>
    </Container>
  );
}

export const Container = styled.div`
  ${({ theme }) => css`
    display: block;
    position: absolute;
    z-index: 5;
    top: 16px;
    left: 0;
    padding: ${theme.layout.chat_header_height} ${theme.layout.section_side} 0;
  `}
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;

  & > img {
    width: 44px;
    height: 44px;
  }
`;
